// extracted by mini-css-extract-plugin
export default {"quantityField":"CartTable_quantityField__4IxdN","removeButton":"CartTable_removeButton__hi0v2","cartTable":"CartTable_cartTable__R7j5m"};